import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchTeams } from "./api";

const initialState = {
    data: { loading: false }
};

export const fetchTeamsAsync = createAsyncThunk(
    'team/fetch',
    async (params) => {
        const response = await fetchTeams(params);
        return response.data;
    }
);

export const teamSlice = createSlice({
    name: 'team',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchTeamsAsync.pending, state => {
                state.data.loading = true;
            })
            .addCase(fetchTeamsAsync.fulfilled, (state, action) => {
                state.data = {};
                action.payload.forEach(team => {
                    state.data[team.code] = team;
                });
                state.data.loading = false;
            })
            .addCase(fetchTeamsAsync.rejected, state => {
                state.data.loading = false;
            });
    },
});

export const selectTeam = (state) => state.team.data;

export default teamSlice.reducer;